import React, { useEffect, useState } from "react";
import OrderListTable from "../../Components/OrderListComponents/OrderListComponents";
import sales_management_service from "../../services/sales_management_service";
import { useDispatch } from "react-redux";
import { setOrdersList } from "../../reducers/sales_management_reducer";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const OrderListPage: React.FC = () => {
  const dispatch = useDispatch();
  const { ordersList } = useSelector(
    (state: RootState) => state?.salesManagementReducer
  );
  const [vendorOrdersList, setVendorOrdersList] = useState<any[]>([]);
  const [vendorsList, setVendorsList] = useState<{ vendor_id: number; vendor_name: string }[]>([]);

  useEffect(() => {
    if (ordersList?.length === 0) {
      sales_management_service.getOrdersListList().then((res) => {
        dispatch(setOrdersList(res.data.orders));
      });
    }
    sales_management_service.getOrdersByVendors().then((res) => {
      setVendorOrdersList(res.data.orders || []);
    }).catch(() => {
      setVendorOrdersList([]);
    });
    sales_management_service.getVendors().then((res) => {
      setVendorsList(res.data.vendors || []);
    }).catch(() => {
      setVendorsList([]);
    });
  }, []);

  return <OrderListTable vendorOrdersList={vendorOrdersList} vendorsList={vendorsList} />;
};

export default OrderListPage;
